module.exports = __webpack_public_path__ + "img/logoEpais.1dfb779c.svg";